export default {"profile.cardHeader":"Profile","profile.form.respondentType.label.firstname":"First name"}